const authForm = {
  el: {
    root: document.querySelector<HTMLElement>('.auth-form'),
    navButtons: document.querySelectorAll<HTMLButtonElement>('.auth-form__nav-button'),
    forms: document.querySelectorAll<HTMLFormElement>('.auth-form__form'),
    methods: document.querySelector<HTMLElement>('.auth-form__method'),
    steps: document.querySelectorAll<HTMLElement>('.auth-form__step'),
    simForm: document.querySelector<HTMLFormElement>('.auth-form__form[data-method="sim"]'),
    appForm: document.querySelector<HTMLFormElement>('.auth-form__form[data-method="app"]'),
    message: document.querySelector<HTMLElement>('.auth-form__message'),
    inputs: document.querySelectorAll<HTMLInputElement>('.auth-form .input-group__input'),
    challengeText: document.querySelector<HTMLElement>('.auth-form__challenge-text'),
  },
  init() {
    this.handleNav()
    this.formEvents()
    this.inputEvents()
  },
  handleSubmit(form: HTMLFormElement) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault()
      try {
        const formData = new FormData(form)

        const data: any = {
          authType: formData.get('authType'),
          phoneOrSSN: formData.get('PhoneOrSsn'),
          type: formData.get('type'),
        }

        // biome-ignore lint/complexity/useLiteralKeys: <explanation>
        const antiforgeryToken = form['__RequestVerificationToken'].value
        const request = await fetch('/umbraco/surface/auth/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            RequestVerificationToken: antiforgeryToken,
          },
          body: JSON.stringify(data),
        })

        if (!request.ok) {
          console.error('[auth-form | submit | !request.ok]')
          this.handleMessage(true, 'error')
          return
        }

        this.poll(request, antiforgeryToken, form)
      } catch (error) {
        console.error('[auth-form | catcn | error]', error)
      }
    })
  },
  async poll(request, antiforgeryToken, form) {
    const res = await request.json()
    this.changeStep(2, res)
    const type = form.querySelector('input[name="type"]')?.value
    const req = await fetch('/umbraco/surface/auth/PollAuthorizationStatus', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        RequestVerificationToken: antiforgeryToken,
      },
      body: JSON.stringify({
        culture: 'is-IS',
        authIdentifier: res.identifier,
        type: type,
      }),
    })
    const response = await req.json()
    if (!response.success || !req.ok) {
      console.error('[auth-form | poll | !req.ok]')
      this.changeStep(1)
      this.handleMessage(true, 'error')
      return
    }

    if (response.success) {
      window.location.href = response.redirect
    }
  },
  handleMessage(show = false, type = 'error') {
    if (show) {
      this.el.message.style.display = 'block'

      setTimeout(() => {
        this.el.message.style.display = 'none'
      }, 10000)
    } else {
      this.el.message.style.display = 'none'
    }

    this.el.message.classList.add(`message--${type}`)
  },
  //getFormData(form: HTMLFormElement) {
  //  const formData = new FormData(form)
  //  // Initialize an object to store the plain form data
  //  const plainFormData: Record<string, any> = {}

  //  // Loop over the entries in the FormData object and populate the plainFormData object
  //  formData.forEach((value, key) => {
  //    // Convert the value into an array if necessary
  //    if (Array.isArray(plainFormData[key])) {
  //      ;(plainFormData[key] as any[]).push(value)
  //    } else {
  //      plainFormData[key] = [plainFormData[key], value]
  //    }
  //  })

  //  return plainFormData
  //},
  changeStep(stepNumber: number, request = null) {
    this.el.steps.forEach((step) => {
      step.style.display = 'none'
    })
    const chosenStep = this.el.root.querySelector<HTMLElement>(`.auth-form__step[data-step="${stepNumber}"]`)
    if (chosenStep) {
      chosenStep.style.display = 'block'
    }

    if (stepNumber === 2) {
      this.el.challengeText.innerText = request.challenge
    }
  },
  handleNav() {
    this.el.navButtons.forEach((button) => {
      button.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
        this.changeForm(e.target.dataset.method)
      })
    })
  },
  changeForm(method: string) {
    this.el.forms.forEach((item) => {
      item.classList.remove('auth-form__form--active')
    })
    this.el.navButtons.forEach((button) => {
      button.classList.remove('auth-form__nav-button--active')
    })
    this.el.root
      .querySelector(`.auth-form__form[data-method="${method}"]`)
      ?.classList.add('auth-form__form--active')
    this.el.root
      .querySelector(`.auth-form__nav-button[data-method="${method}"]`)
      ?.classList.add('auth-form__nav-button--active')
  },
  formEvents() {
    this.el.forms.forEach((form) => {
      this.handleSubmit(form)
    })
  },
  inputEvents() {
    this.el.inputs.forEach((input) => {
      // This prevents ctrl + v
      input.onpaste = (e) => e.preventDefault()

      input.addEventListener('keyup', (e: Event & { target: HTMLInputElement; key: string }) => {
        if (e.key !== 'Backspace') {
          const regex = /^[0-9-]*$/

          if (!regex.test(e.target.value)) {
            // If the input doesn't match the pattern, clear the input value
            e.target.value = e.target.value.replace(/[^0-9-]/g, '')
          }
        }

        const parent = e.target.closest<HTMLElement>('.auth-form__input-wrap')

        if (e.target.value.length >= e.target.maxLength) {
          parent?.querySelector<HTMLButtonElement>('.auth-form__submit')?.removeAttribute('disabled')
        } else {
          parent?.querySelector<HTMLButtonElement>('.auth-form__submit')?.setAttribute('disabled', '')
        }
      })
    })
  },
}

export default authForm
